/**
 * @summary Verifica se o erro é um erro HTTP.
 * @param {Error} error
 * @returns {Boolean} True se for um erro http.
 */
const CheckIfIsHTTPError = function(error)
{
	return !!error.response;
};

const HandleError = function(error)
{
	// Objeto erro custom.
	const customError = {
		message:     "",
		status:      "",
		details:     {} || [ "" ],
		isHTTPError: false,
	};

	// Se for um erro http
	if (CheckIfIsHTTPError(error))
	{
		customError.message = error.response.data.message;
		customError.status = error.response.data.code;
		customError.details = error.response.data.details;
		customError.isHTTPError = true;
		return customError;
	}
	// Se for erro JS.
	customError.message = error.message;
	customError.status = error.name;
	customError.details = error;
	customError.isHTTPError = false;
	return customError;
};

export default { HandleError };